import { TransactionTypeEnum } from '../enums/transaction-type.enum';

/**
 * Returns true if the transaction type can have a payment (RECEIPT, DEPOSIT, REFUND).
 */
export function isPaymentBearingTransactionType(
	type: TransactionTypeEnum | undefined | null,
): boolean {
	if (!type) {
		return false;
	}
	return (
		type === TransactionTypeEnum.RECEIPT ||
		type === TransactionTypeEnum.DEPOSIT ||
		type === TransactionTypeEnum.REFUND
	);
}
